import { useEffect, type ReactNode } from 'react';
import { AuthGate } from './components/AuthGate';
import { Shell, type NavItem } from './components/Shell';
import { Toaster } from './components/toast';
import { UpdateWatcher } from './components/UpdateWatcher';
import { takeGoogleNotice } from './lib/google';
import { usePrefs } from './lib/prefs';
import { toast } from './components/toast';
import { useHashRoute } from './lib/router';
import { Agents } from './views/Agents';
import { Calendar } from './views/Calendar';
import { Conversation } from './views/Conversation';
import { Email } from './views/Email';
import { News } from './views/News';
import { HomeHud } from './views/HomeHud';
import { Projects } from './views/Projects';
import { Settings } from './views/Settings';

const NAV: NavItem[] = [
  { id: 'visao-geral', label: 'Visão Geral', icon: 'home' },
  { id: 'conversa', label: 'Conversa', icon: 'chat' },
  { id: 'noticias', label: 'Notícias', icon: 'news' },
  { id: 'email', label: 'E-mail', icon: 'mail' },
  { id: 'agenda', label: 'Agenda', icon: 'calendar' },
  { id: 'projetos', label: 'Projetos', icon: 'folder' },
  { id: 'agentes', label: 'Agentes', icon: 'agent' },
  { id: 'configuracoes', label: 'Configurações', icon: 'settings', bottom: true }
];
const DEFAULT_VIEW = 'visao-geral';

function renderView(id: string, params: string[]): ReactNode {
  switch (id) {
    case 'conversa': return <Conversation />;
    case 'noticias': return <News />;
    case 'email': return <Email params={params} />;
    case 'agenda': return <Calendar />;
    case 'projetos': return <Projects />;
    case 'agentes': return <Agents />;
    case 'configuracoes': return <Settings params={params} />;
    default: return null;
  }
}

export function App() {
  const { theme } = usePrefs();
  const { view, params } = useHashRoute();
  const item = NAV.find((n) => n.id === view);

  /* Resultado da volta do Google (conectar Gmail), mostrado uma vez. */
  useEffect(() => {
    const n = takeGoogleNotice();
    if (n) window.setTimeout(() => toast(n.text, n.ok ? 'check' : 'alert'), 400);
  }, []);

  useEffect(() => {
    if (!item) window.location.replace(`#/${DEFAULT_VIEW}`);
  }, [item]);

  useEffect(() => {
    const root = document.documentElement;
    if (theme === 'system') delete root.dataset.theme;
    else root.dataset.theme = theme;
  }, [theme]);

  useEffect(() => {
    document.title = `${item?.label ?? 'Visão Geral'} · Jarvis Master`;
    if (!params.length) window.scrollTo(0, 0);
  }, [view]);

  const current = item ?? NAV[0]!;
  return (
    <>
      <UpdateWatcher />
      <AuthGate>
        {current.id === DEFAULT_VIEW
          ? <HomeHud />
          : (
            <Shell items={NAV} current={current.id} title={current.label}>
              <div key={current.id}>{renderView(current.id, params)}</div>
            </Shell>
          )}
      </AuthGate>
      <Toaster />
    </>
  );
}
